import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgG2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 52,
	height: 52,
	viewBox: "0 0 1000 1000",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 500,
			cy: 500,
			r: 500,
			fill: "#ff492c"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fefefe",
			d: "M716.4 383H631c2.3-13.4 10.6-20.9 27.4-29.4l15.7-8c28.1-14.4 43.1-30.7 43.1-57.3 0-16.7-6.5-29.9-19.4-39.4s-28.1-14.2-45.9-14.2a70.8 70.8 0 0 0-38.9 11.1c-11.7 7.2-20.4 16.5-25.8 28.1l24.7 24.8c9.6-19.4 23.5-28.9 41.8-28.9 15.5 0 25 8 25 19.1 0 9.3-4.6 17-22.4 26l-10.1 4.9c-21.9 11.1-37.1 23.8-45.9 38.2s-13.1 32.5-13.1 54.4v6h129.2zM705 459.2H563.6l-70.7 122.4h141.4L705 704.1l70.7-122.5L705 459.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fefefe",
			d: "M505.1 663.3c-90 0-163.3-73.3-163.3-163.3s73.3-163.3 163.3-163.3L561 219.8a286.4 286.4 0 0 0-55.9-5.5c-157.8 0-285.7 127.9-285.7 285.7s127.9 285.7 285.7 285.7a283.9 283.9 0 0 0 168.2-54.8l-61.8-107.2a162.8 162.8 0 0 1-106.4 39.6z"
		})
	]
});
export default SvgG2;
